// @ts-check
import { th } from "intl-tel-input/i18n";
export class Menu{    
/**
 * 
 * @param {any} main 
 * @param {any} state 
 */
constructor(main,state){
this.controller = new AbortController();
this.cleanups = [];
this.evtHandlers = [];
this.m = this.main = main;
this.state = state;
//
this.maxId = 0;
//
this.selectedMenu = null;//temporary hold
//
this.menu$ = null;
this.menus$ = null;

/**@type {any}*/this.displayMenus = null;
}//
async setDisplay(){
if(this.state.stateObject){
if(this.state.type=='list'){
this.menus$ = this.state.stateObject.menus;
this.displayMenus = this.menus$;
}else{
if(this.state.type=='new' && this.state.id==-1){
this.menu$ = this.getNewMenu();
}else if(this.state.type=='edit'){
this.menu$ = this.state.stateObject.menu;
}
}
}//
}//func

async getListTemplate(){
await this.setDisplay();
let $this = this;//cu
    //get handles
this.menuComponent= this.main.pbu.createElement('main',['menu-component']);
this.menuComponent.innerHTML =
`
<section>
<header>
    <a type="button" href="${this.main.getLink('menu','page','new',-1)}" class="btn btn-primary new-menu sp-admin sp-route-link">Add Menu </a> 
</header>

<section class="sp-table menu-list-table">
</section>

</section>
`;
//handle
this.menuTable = this.menuComponent.querySelector('.menu-table');
this.menuListTableSection = this.menuComponent.querySelector('.menu-list-table'); 
await updateView();
addEvents();
this.cleanups.push(()=>{$this = null;});
return this.menuComponent;
async function updateView(){
$this.setListTable();
}//inner
function addEvents(){

}//inner
}//func
async setListTable(){
let titles = ["Title","Description"];
let posts = [];
let p = null;
for(let m of this.displayMenus){
p = {
id:m.id,
href:this.main.getLink('menu','page','edit',m.id),
titles:[m.title,m.description],
editHref:this.main.getLink('menu','page','edit',m.id),
deleteHref:``,
};
posts.push(p);
}//for
let menuTable = await this.main.pbu.createTable({titles:titles,posts:posts});
this.main.pbu.replace(this.menuListTableSection,menuTable);
this.cleanups.push(()=>{titles = p = posts = menuTable = null;});
}//func
async getFormTemplate(){
await this.setDisplay();
let $this = this;//cu
this.menuComponent= this.main.pbu.createElement('main',['menu-component']);
this.main.pbu.appendChild(this.menuComponent,
`
<div class="container">
${this.main.pbu.createFormControl({title:"Title",value:this.menu$.title,clasz:['title'],required:true,serialize:true})}
${this.main.pbu.createFormControl({title:"Description",value:this.menu$.description,clasz:['description'],serialize:true})}
 <!--##########-->
<div class="row">
    <div id = "editSection" class="col-12">
      <h5>Build Section</h5>
      <div class="row menu-row">
        <div class="col-2">
 ${this.main.pbu.createSelectElement({serialize:true,value:'Pages',clasz:['menu-item-type'],items:['Pages','Posts','Post Categories','Product Categories','Custom']})} 
        </div>
        <div class="col-6">
        ${this.main.pbu.createFormControl({placeholder:'Search',clasz:['menu-search'],serialize:true})}
        <div class="position-relative">
          <ul class="list-group mt-2 menu-selected d-none position-absolute" style="z-index: 101;">
          </ul>
          </div>
        </div>
        <div class="col-2 sp-form-control">
        ${this.main.pbu.createFormControl({placeholder:'Label',clasz:['menu-label','sp-validation-required'],serialize:true})}
        </div>
        <div class="col-2"><button class="menu-add">Add</button></div>
      </div>
    </div>

    <!--Selected Menu-->
    <div>
      <ul id = "displaySection" class="list-group">
      <h5>Selected Menu</h5>
    </ul>
    </div>
    
    <!--#Selected Menu--> 
    </div>
      </div>
`
);
//edit section
this.menuTitleControl = this.menuComponent.querySelector('input.title');
this.menuDescriptionControl = this.menuComponent.querySelector('input.description');
this.menuItemTypeSelector = this.menuComponent.querySelector('.menu-item-type');
this.menuSearchControl = this.menuComponent.querySelector('.menu-search');
//this.menuCustomLinkControl = this.menuComponent.querySelector('.menu-custom-link');
this.menuSelectedList = this.menuComponent.querySelector('.menu-selected');
this.menuLabelControl = this.menuComponent.querySelector('.menu-label');
//to add selected menu
this.menuAddButton = this.menuComponent.querySelector('.menu-add'); 

//display section
this.displaySection = this.menuComponent.querySelector('#displaySection');
this.draggingItem = null;

//
await updateView();
addEvents();
this.cleanups.push(()=>{$this  = null;});
return this.menuComponent;

async function updateView(){
if(! $this.menu$.menuItems){return;}
let menuItems = JSON.parse($this.menu$.menuItems) || [];//string array
let maxIds = menuItems.map(mi=>mi.menuId);
$this.maxId =  Math.max(...maxIds);
//
let li,dropZone,subMenu,subMenuLi,subMenuDropZone;
  for(let m of menuItems){
    li = addMenus(m);
    $this.displaySection.appendChild(li);
    //let children = m.children;
    if(m.children?.length>0){
    dropZone = li.querySelector('div.drop-section');
    subMenu = li.querySelector('ul.submenu');
    $this.main.pbu.show(dropZone);
   for(let c of m.children){
    subMenuLi = addMenus(c);
    subMenuDropZone = subMenuLi.querySelector('div.drop-section');
    $this.main.pbu.removeClass(subMenuDropZone,['drop-zone']);
    $this.main.pbu.hide(subMenuDropZone);
    subMenu.appendChild(subMenuLi);
  }
}
  }
  $this.cleanups.push(()=>{menuItems=maxIds=li=dropZone=subMenu=subMenuLi=subMenuDropZone=null;});
}

async function addEvents(){
  $this.main.pbu.listen($this.menuItemTypeSelector,'change',()=>{
    if($this.menuItemTypeSelector.value=='Custom'){
      $this.menuSearchControl.placeholder = 'Link';
    }else{
      $this.menuSearchControl.placeholder = 'Search';
    }
  });
  
  //search
  $this.main.pbu.listen($this.menuSearchControl,'input',()=>{
    $this.menuSelectedList.innerHTML = '';
    let searchTerm = $this.menuSearchControl.value;
    if(searchTerm){
    let regex = new RegExp(`^${searchTerm}`, "i");
    let itemType = $this.menuItemTypeSelector.value;
    let archiveType;
    let items;
    let component;
    switch(itemType){
      case 'Pages':
        component = 'post';
        archiveType = 's';
        items = $this.state.stateObject.posts.filter(p=>p.postType=='page');
        break;
      case 'Posts':
        component = 'post';
        archiveType = 's';
        items = $this.state.stateObject.posts.filter(p=>p.postType=='post');
        break;
      case 'Post Categories':
        component = 'category';
        archiveType = 'postcategory';
        items = $this.state.stateObject.categories.filter(c=>c.postType=='post');
        break;
      case 'Product Categories':
        component = 'category';
        archiveType = 'productcategory';
        items = $this.state.stateObject.categories.filter(c=>c.postType=='product');
        break;
    }
        items = items.filter(i=>regex.test(i.title));
        if(items){
        for(let i of items){
        let li = $this.main.pbu.createElement('li',['list-group-item'],i.title);//cu-d
        $this.menuSelectedList.appendChild(li);
        //
        $this.main.pbu.listen(li,'click',()=>{
          $this.selectedMenu = {
                            menuId:++$this.maxId,
                            component:component,
                            postType:i.postType,
                            archiveType:archiveType,
                            title:i.title,
                            postId:i.id,
                            slug:i.slug,
                            parentId:0,
                            children:[]
                            };
$this.main.log($this.selectedMenu,'Menu.getFormTemplate.addEvents(): selectedMenu');
          $this.menuSearchControl.value= $this.selectedMenu.title;
          $this.menuSelectedList.innerHTML = '';
          $this.main.pbu.hide($this.menuSelectedList);
        },$this);
      }
      $this.main.pbu.show($this.menuSelectedList);
        }

        $this.cleanups.push(()=>{searchTerm=regex=itemType=archiveType,component=items=null;});
    }
  });
  //
$this.main.pbu.listen($this.menuAddButton,'click',()=>{
let postType = $this.menuItemTypeSelector.value;
let isCustom = postType=='custom';
let menuControl;
if(isCustom){
  menuControl = $this.menuCustomLinkControl;
}else{
  menuControl = $this.menuSearchControl;
}
if(!$this.main.vu.validate(menuControl,$this.menuLabelControl)){
  return;
}
if(isCustom){
  $this.selectedMenu = {
                            menuId:++$this.maxId,
                            postId:null,
                            title:$this.menuLabelControl.value,
                            link:menuControl.value,
                            postType:'custom',
                            parentId:0,
                            children:[]
                            };
}else{
//note: if not isCustom, selected menu is the previously saved menu
$this.selectedMenu.title = $this.menuLabelControl.value;
}

//add to display section
let li = addMenus($this.selectedMenu);
$this.displaySection.appendChild(li);
//reset forms
menuControl.value = '';
$this.menuLabelControl.value = '';
$this.main.pbu.removeClass(menuControl,$this.main.config.VALIDATION_REQUIRED_CLASS);
$this.main.pbu.removeClass($this.menuLabelControl,$this.main.config.VALIDATION_REQUIRED_CLASS);
$this.selectedMenu = null;
$this.cleanups.push(()=>{postType=isCustom=menuControl=li=null;});
});//addMenu click
}//inner


/**
 * 
 * @param {any} selectedMenu 
 */
function addMenus(selectedMenu){
let smd = JSON.stringify(selectedMenu);
let row = $this.main.pbu.createElement('li',['drag-item','list-group-item']);
row.style.cursor='move';
row.innerHTML = 
`
<div class="d-flex my-2">
<p class="me-4 menu-label">${selectedMenu.title}</p>
<button class="mx-2 menu-edit">Edit</button>
<button class="mx-2 menu-delete">Delete</button>
</div>

 <div class="drop-zone drop-section w-100 my-1 d-none" style="border: 1px dashed blue;">
  <ul class="list-group submenu" style="margin-left: 50px;border: 1px dashed blue;">
  <li class="list-group-item">SubMenu</li>
  </ul>
  </div>
`;
row.setAttribute("draggable","true");
row.setAttribute("data-selected-menu",smd);
//handle
let menuLabel = row.querySelector('.menu-label');
let menuEdit = row.querySelector('.menu-edit');
let menuDelete = row.querySelector('.menu-delete');
let dropZone = row.querySelector('div.drop-zone');

//Edit
$this.main.pbu.listen(menuEdit,'click',()=>{
let modal = $this.main.utils.setModal('Change Label',null);
//
$this.main.pbu.listen(modal.confirm,'click', ()=>{
  if(!$this.main.vu.validate(modal.input)){
  return;
}
let newLabel = modal.input.value;
//validate
  selectedMenu.title = newLabel;
  menuLabel.textContent = newLabel;
  let smd = JSON.stringify(selectedMenu);
  row.setAttribute('data-selected-menu',smd);
  modal.dismiss.click();
},$this);
});

//delete
$this.main.pbu.listen(menuDelete,'click',()=>{
let modal = $this.main.utils.setModal('Deletion Menu','blanc');
$this.main.pbu.listen(modal.confirm,'click', ()=>{
let submenu = row.closest('ul.submenu');
if(submenu){
let subMenuItems = submenu.querySelectorAll('li.drag-item');
if(subMenuItems.length==1){//row inclusive
$this.main.pbu.hide(submenu.parentElement);
}
}
row.remove();
modal.dismiss.click();
},$this);
});

//drag
$this.main.pbu.listen(row,'dragstart',(e)=>{
$this.draggingItem = e.target;
$this.draggingItem.style.cursor='move';
$this.main.pbu.addClass($this.draggingItem,['dragging']);
let  draggableItems = [...$this.displaySection.querySelectorAll(".drag-item:not(.dragging)")];
for(let di of draggableItems){
  let dropZone = di.querySelector('div.drop-zone');
  if(dropZone){
    $this.main.pbu.show(dropZone);
  }
  
}
},$this);
//
$this.main.pbu.listen(row,'dragend',(e)=>{
$this.main.pbu.removeClass(e.target,['dragging']);
setTimeout(() => {
let  draggableItems = [...$this.displaySection.querySelectorAll(".drop-zone")];
for(let di of draggableItems){
  let ul = di.querySelector('ul');
  //dont hide drop zone, when an item has been added to sub menu
  if(ul.children.length==1){
    $this.main.pbu.hide(di);
  }
  
}
}, 2000);

},$this);
//
//
$this.main.pbu.listen(row,'dragover',(e)=>{
e.preventDefault();
});
//
$this.main.pbu.listen(row,'drop',(e)=>{
e.preventDefault();
let dropZoneDiv = row.querySelector("div.drop-zone");
let dropZoneRect = dropZoneDiv.getBoundingClientRect();
let dropZoneTop = dropZoneRect.top;

let ul = row.querySelector("ul");
let ulRect = ul.getBoundingClientRect();

let yPos = e.clientY;
let xPos = e.clientX;
if(yPos>dropZoneTop){
  if(xPos<ulRect.left){
    row.after($this.draggingItem);
    $this.main.pbu.addClass($this.draggingItem.querySelector('div.drop-section'),['drop-zone']);
  }else{
    ul.appendChild($this.draggingItem);
    $this.main.pbu.removeClass($this.draggingItem.querySelector('div.drop-section'),['drop-zone']);
  }
  
}
},$this)
return row;
}//inner
}//func

async save(){
if(!this.main.vu.validate(this.menuTitleControl,this.menuDescriptionControl)){
return;
}
  let title = this.menuTitleControl.value;
  let displayMenu = [];
  let selectedMenuLi = this.displaySection.querySelectorAll(':scope > li')||[];
  let dmd,dm,subMenuLi,sm,smd;
  for(let li of selectedMenuLi){
    dmd = this.main.pbu.getAttribute(li,'data-selected-menu');//displayMenuData
    dm = JSON.parse(dmd);
    displayMenu.push(dm);
    subMenuLi = li.querySelectorAll('li.drag-item');
      for(let i=0;i<subMenuLi.length;i++){
        smd = this.main.pbu.getAttribute(subMenuLi[i],'data-selected-menu');//subMenuData
        sm = JSON.parse(smd);
        sm.parentId = dm.menuId;
        dm.children.push(sm);
      }
    
  }

let menu = {
id: this.state.id,
title:title,
slug:title.toLowerCase(),
description:this.menuDescriptionControl.value,
menuItems:JSON.stringify(displayMenu),
};
this.main.setTenant(menu);
this.main.log(menu,'Menu.saveMenu(): Before submit');
let state = this.main.utils.clone(this.state);
state.body = JSON.stringify(menu);
let r = await this.main.fu.fetch(state);
if(r>0){
this.state = this.main.replaceState(this.menu$,this.state,r);
this.main.utils.notify('Saved',{level:0});
}
this.main.utils.finilizeSave(this);
this.cleanups.push(()=>{title=displayMenu=selectedMenuLi=dmd=dm=subMenuLi=sm=smd=menu=state=r=null;});
}//func

//######
getNewMenu(){
return {
id:-1,
title:"",
slug:"",
description:"",
menuItems:"",
username:"",
tenantId:-1,
tenantUuid:""
};
}//func
getItems(){
    return this.menus$;
}
/**
 * 
 * @param {any} items 
 */
async setItems(items){
this.state.stateObject.menus = items;
await this.setDisplay();
}
}//class
